export const PropertyCardSkeleton = () => (
  <article className="skeleton-card" aria-hidden="true">
    <span className="skeleton image" />
    <div className="skeleton-card-body">
      <span className="skeleton title" />
      <span className="skeleton text" />
      <span className="skeleton text short" />
    </div>
  </article>
);

export const PropertyCardSkeletonGrid = ({ count = 6 }) => (
  <div className="skeleton-card-grid">
    {Array.from({ length: count }).map((_, index) => (
      <PropertyCardSkeleton key={index} />
    ))}
  </div>
);
